export default __webpack_public_path__ + "static/media/7.0fa4e07a.mp4";